import React from 'react';
import {curry} from 'ramda';
import Moment from 'moment';
import wrap from 'wraptile';
import {extendMoment} from 'moment-range';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import SummaryItem from './SummaryItem';
import {SummaryProps, Section, SummaryResponse} from './SummaryTypes';
import {DateRangeState} from '../../daterange-picker';

const moment = extendMoment(Moment as any);

export const getLastTwoWeekRange = () => {
    const start = moment().startOf('day').add(-2, 'weeks');
    const end = moment().startOf('day');
    return moment.range(start, end);
};

export const getRangeFromStatus = (
    dates: DateRangeState,
    complete: boolean | undefined
) => {
    if (complete) return getLastTwoWeekRange();

    return dates;
};

export const onStatusClick = wrap(
    (qcJobStatus: string[], props: SummaryProps, complete: boolean) => {
        const {setFilter, setDates, dates} = props;
        const newDates = getRangeFromStatus(dates, complete);
        setDates(newDates);
        setFilter({
            qcJobStatus,
            newDates,
        });
    }
);

export const getItems = curry((props: SummaryProps, section: Section) => {
    const {status, title, complete} = section;
    const [firstStatus] = status;
    const {state} = props;
    const text = state[firstStatus as keyof SummaryResponse];
    return (
        <SummaryItem
            key={title}
            text={text as number}
            type={title}
            onClick={onStatusClick(status, props, complete)}
        />
    );
});

function SummaryContainer(props: SummaryProps) {
    const {onExport, sections} = props;
    const withProps = getItems(props);
    const items = sections.map(withProps);
    return (
        <Box className="qc-manager-bar">
            <Box className="qc-manager-bar__actions">{items}</Box>
            {Boolean(onExport) && (
                <Button onClick={onExport} data-testid="qc-jobs-export">
                    Export
                </Button>
            )}
        </Box>
    );
}

export default SummaryContainer;
